import React from 'react'
import Navbar from './Pages/Navbar'
import Header from './Pages/Header'
import WhyChooseUs from './Pages/whychooseus'
import HowWeWork from './Pages/Howitworks'
import Reviews from './Pages/Review'
import Footer from './Pages/Footer'
import AllRoutes from './Allroutes'

const App = () => {
  return (
    <div>
      <AllRoutes/>
    </div>
  )
}

export default App
